module.exports = __webpack_public_path__ + "07_long_black.4791665f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/07_long_black.png
// module id = ag6t
// module chunks = 0